import React from "react";
import PermissionContainer from "../containers/Permission";

const Permission = () => {
  return <PermissionContainer />;
};

export default Permission;
